// Code review - In Progress
// Documentation - In Progress
import React, { forwardRef } from "react";
import PropTypes from "prop-types";
import { mainTable } from "../css/Common";
import Select from "react-select";

const AutoDropDown = forwardRef((props, ref) => {
 
  const defaultOption = { value: null, label: props?.placeholder || "Select an option" };
  const safeOptions = Array.isArray(props?.options) ? props.options : [];
const optionsWithDefault = props?.classStar
  ? safeOptions
  : [defaultOption, ...safeOptions];

  return (
    <div className={props?.classDiv ? props?.classDiv : "form-group"}>
      <label className={props?.ClassLabel ? props?.ClassLabel : mainTable.label}>
        {props.title}
        <span className={props?.classStar ? props?.classStar : "hidden"}>*</span>
      </label>
      <Select
        ref={ref}
        name={props.name}
        value={props.selectedOption}
        onChange={props.controlFunc}
  menuPortalTarget={props.menuPortalTarget} 
        onBlur={props.controlFuncBlur}
        className={props.Class ? props.Class : mainTable.input}
        isDisabled={props.disabled}
        placeholder={props.placeholder}
        tabIndex={props.tabIndex}
        styles={customStyles}
        options={optionsWithDefault}
      />
      {props.errorMessage && (
        <span className="text-red-500 text-sm font-medium">{props.errorMessage}</span>
      )}
    </div>
  );
});

AutoDropDown.propTypes = {
  name: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string,
    })
  ).isRequired,
  selectedOption: PropTypes.object, // Adjusting this to be an object as it's coming from find
  controlFunc: PropTypes.func.isRequired,
  controlFuncBlur: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool, // Change to bool for better type checking
  tabIndex: PropTypes.string.isRequired,
  errorMessage: PropTypes.string,
  menuPortalTarget: PropTypes.string,
};

export default AutoDropDown;
const customStyles = {
  option: (provided, state) => ({
    ...provided,
    color: 'black', // <-- Black text
    backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
  }),
  singleValue: (provided) => ({
    ...provided,
    color: 'black', // <-- Also ensures selected value is black
  }),
  menu: (provided) => ({
    ...provided,
    zIndex: 9999, // helps if you face z-index issues with modal/popups
  }),
};
